import { EVALUATION_STATES } from "../../Constants/evaluation";
import UserSession from "../../Utils/UserSession";
import { useEffect } from 'react';
export var WIDGET_TO_FILTER = 'valuation-error';
var cleanValuationErrorCookie = function cleanValuationErrorCookie() {
  UserSession.initUserVisitStatus();
  var evalState = UserSession.getUserEvaluationState();
  if (evalState === EVALUATION_STATES.VALUATION_ERROR) {
    UserSession.setUserEvaluationState(EVALUATION_STATES.INITIAL);
  }
};
var useErrorCookie = function useErrorCookie(_ref) {
  var widgetName = _ref.widgetName;
  useEffect(function () {
    var removeCookie = widgetName && widgetName.includes(WIDGET_TO_FILTER);
    if (typeof window !== 'undefined' && removeCookie) {
      window.addEventListener('beforeunload', cleanValuationErrorCookie);
    }
    return function () {
      if (removeCookie) {
        cleanValuationErrorCookie();
        window.removeEventListener('beforeunload', cleanValuationErrorCookie);
      }
    };
  }, [widgetName]);
  return null;
};
export default useErrorCookie;